module.exports = require('./helpers/bundle-url').getBundleURL('15MIF') + "aboutMap.bac5be5d.png";